import { render } from "./XFstatistics.vue?vue&type=template&id=eed9a37a&scoped=true"
import script from "./XFstatistics.vue?vue&type=script&lang=js"
export * from "./XFstatistics.vue?vue&type=script&lang=js"

import "./XFstatistics.vue?vue&type=style&index=0&id=eed9a37a&lang=scss&scoped=true"
import "./XFstatistics.vue?vue&type=style&index=1&id=eed9a37a&lang=css"

import exportComponent from "D:\\workCode\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eed9a37a"]])

export default __exports__